import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Typeahead from './typeahead';
import ResultsList from './results-list';
import Map from './map';

import { SEARCH_TYPES } from '../globals/config';
import { locationsForQuery } from '../utils/data/locations-for-query';
import { BASE_PATH } from "../globals/wp";

export default class Results extends Component {
	static propTypes = {
		country: PropTypes.string,
		lat: PropTypes.string,
		lng: PropTypes.string,
		location: PropTypes.object,
		navigate: PropTypes.func,
		query: PropTypes.string,
		state: PropTypes.string,
		type: PropTypes.string,
		radius: PropTypes.string,
	};

	static defaultProps = {
		country: '',
		lat: '0',
		lng: '0',
		location: {},
		navigate: () => {},
		query: '',
		state: '',
		type: SEARCH_TYPES.distance,
	};

	constructor(props) {
		super(props);

		this.state = {
			locations: this.getLocations(props),
			type: props.type,
			query: props.query,
		};
	}

	componentWillMount() {
		document.addEventListener('modern_tribe/locator/update_radius', this.handleStateRadiusChange);
	}

	componentWillUnmount() {
		document.removeEventListener('modern_tribe/locator/update_radius', this.handleStateRadiusChange);
	}

	handleStateRadiusChange = (e) => {
		// navigate to a new URL
		const { lat, lng, country, state, type, query } = this.props;
		const path = `${BASE_PATH}location/${lat}/${lng}/${country}/${state}/${type}/${query}/${e.detail.radius}/`;
		this.props.navigate(path);
	};

	componentWillReceiveProps(props) {
		// router acting strange on back button history, had to resort to this. They are they looking at some issues
		this.setState({
			locations: this.getLocations(props),
			type: props.type,
		});
	}

	/**
	 * Get the locations based on router props. Uses locationsForQuery
	 * @param props
	 */

	getLocations(props) {
		const { lat, lng, country, state, type, radius } = props;
		return locationsForQuery(parseFloat(lat), parseFloat(lng), country, state, type, parseInt(radius, 10));
	}

	/**
	 * Receives update triggers after address change in typeahed or get location
	 */

	handleUpdate = (e) => {
		const { query } = this.props;
		this.setState({
			locations: this.getLocations(this.props),
			query,
		});
	};

	render() {
		const showMap = this.state.locations.length > 0;
		return (
			<React.Fragment>
				<Typeahead {...this.props} handleUpdate={this.handleUpdate} />
				{showMap ?
					<Map {...this.props} {...this.state} />
					: ''
				}
				<ResultsList {...this.props} {...this.state} />
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/results.js